import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ILogger, LOGGER_TOKEN } from '../services/logger/ilogger';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);

  handleError(error: unknown): void {
    this.logger.exception(error, { source: 'global-error-handler' });
  }
}
